'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.HelpButton', ['AVRO.Common.Configuration', 'AVRO.Common.FeatureToggle']).factory('HelpPageUrlService', require('./services/HelpPageUrlService')).directive('rmHelpButton', require('./directives/HelpButtonDirective'));